module.exports = function getResource(label, vars = []) {
    let resources = {
        makeoverAt: 'Makeover at'
    };

    return resources[label];
};
